import * as C from '../common';

export default data => {
  return C.common_outgoing(data);
};
